import React from 'react';
import { getTranslations } from '../services/translations';

const ErrorPage: React.FC = () => {
  // No company context on this route, so fall back to the browser language
  const translations = getTranslations(navigator.language || 'es-es');

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-4xl font-bold text-gray-900 mb-4">Error</h1>
        <p className="text-gray-600 mb-8">{translations['error.generic'] || 'Something went wrong'}</p>
        <button 
          onClick={() => window.location.reload()} 
          className="inline-flex items-center px-4 py-2 bg-indigo-500 text-white rounded-lg hover:bg-indigo-600 transition"
        >
          Try Again
        </button>
      </div>
    </div>
  );
};

export default ErrorPage;
